import { render, staticRenderFns } from "./OrderAdmittanceClosing.vue?vue&type=template&id=59da41ea&scoped=true&"
import script from "./OrderAdmittanceClosing.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da41ea",
  null
  
)

export default component.exports
import {QItem,QInput,QBtn,QTooltip,QDialog} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QBtn,QTooltip,QDialog}, component.options.components || {})
